import { render } from "./productTabs.vue?vue&type=template&id=40e2ecc4&ts=true"
import script from "./productTabs.vue?vue&type=script&lang=ts"
export * from "./productTabs.vue?vue&type=script&lang=ts"

import "./productTabs.vue?vue&type=style&index=0&id=40e2ecc4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__